import { render, staticRenderFns } from "./InsightArticlePage.vue?vue&type=template&id=7a683fd5&scoped=true&"
import script from "./InsightArticlePage.vue?vue&type=script&lang=js&"
export * from "./InsightArticlePage.vue?vue&type=script&lang=js&"
import style0 from "./InsightArticlePage.vue?vue&type=style&index=0&id=7a683fd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a683fd5",
  null
  
)

export default component.exports